export const DEFAULT_APP_THEME = "theme-1";
export const POINTS_CURRENCY_CODE = "STC";

export const DEFAULT_COUNTRY = {
  name: "United States",
  iso: "US",
  iso3: "USA",
  international: false,
};
